export default __webpack_public_path__ + "navigation-examples-location-snapping-thumbnail-960-d6c829e7d22ee2a3b1194eb2e5e63da6.png";